import { render, staticRenderFns } from "./ProductObtainingGraph.vue?vue&type=template&id=7fa894ba&scoped=true&lang=pug&"
import script from "./ProductObtainingGraph.vue?vue&type=script&lang=ts&"
export * from "./ProductObtainingGraph.vue?vue&type=script&lang=ts&"
import style0 from "./ProductObtainingGraph.vue?vue&type=style&index=0&id=7fa894ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa894ba",
  null
  
)

export default component.exports